module.exports = __webpack_public_path__ + "static/img/6587_phase_function_Paper_Points.829a959.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6587_phase_function_Paper_Points.png
// module id = vx6u
// module chunks = 0